import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
@Component({
  selector: 'app-confirmation',
  imports: [ConfirmPopupModule, TranslateModule, ButtonModule],
  templateUrl: './confirmation.component.html',
  styleUrl: './confirmation.component.scss',
  providers: [MessageService],
})
export class ConfirmationComponent {}
